class SafetextSender {
  sendIntervalInMs = 250; //Max time interval in "standard"
  maxCharsToSend = 250; //Max chars to send in each SIP msg

  seq = 0;
  buffert = [];

  userAgent = null;
  mmxCallId = null;
  uri = null;

  constructor() {
    setTimeout(() => this.loop(), this.sendIntervalInMs);
    this.reset();
  }

  reset = () => {
    this.buffert = [];
    this.seq = 0;
  };

  loop = () => {
    //console.error("mmxCallId="+ this.mmxCallId);
    //console.error("userAgent="+ this.userAgent);
    if (
      this.buffert.length > 0 &&
      (this.mmxCallId == null || this.userAgent == null)
    ) {
      //mmxcallid or useragent is not set
      //we dont know who to send to
      //console.error("mmxCallId=" + this.mmxCallId);
      //console.error("userAgent=" + this.userAgent);
    } else {
      try {
        var str = "";
        while (this.buffert.length > 0 && str.length < this.maxCharsToSend) {
          var c = this.buffert.pop();
          if (c) {
            str = str + c;
          }
        }
        if (str.length > 0) {
          this.sendSipMessage(str);
        }
      } catch (exc) {
        console.error(exc);
      }
    }

    setTimeout(() => this.loop(), this.sendIntervalInMs);
  };

  sendSipMessage = message => {
    this.seq++;
    this.userAgent.message(this.uri, message, {
      extraHeaders: [
        "P-MMX-Text-Offer: " + this.seq,
        "P-Safe-Text: " + this.seq,
        "P-MMX-TEXT-DST: " + this.mmxCallId,
      ],
    });
  };

  send = str => {
    if (str.length > this.maxCharsToSend * 4) {
      console.error("Too many characters entered, size=" + str.length);
      return;
    }
    try {
      if (!str) return;
      if (str.length < 1) return;

      for (var x = 0; x < str.length; x++) {
        var c = str.charAt(x);
        this.buffert.unshift(c);
      }
    } catch (exc) {
      console.error(exc);
    }
  };
}

export default SafetextSender;



// WEBPACK FOOTER //
// ./src/misc/safetextSender.js